// src/components/AssetIndexDataGridColumns.js

export const assetColumns = [
  {
    field: 'createdAt',
    headerName: 'Created',
    width: 170,
    valueGetter: (params) =>
      params.row.createdAt ? new Date(params.row.createdAt).toLocaleString() : '',
  },
  {
    field: 'name',
    headerName: 'Name',
    width: 220,
  },
  {
    field: 'description',
    headerName: 'Description',
    width: 260,
    renderCell: (params) => <div>{params.value}</div>,
  },
  {
    field: 'type',
    headerName: 'Asset Type',
    width: 120,
  },
  {
    field: 'fileType',
    headerName: 'File Type',
    width: 100,
  },
  {
    field: 'language',
    headerName: 'Language',
    width: 90,
  },
  {
    field: 'projectToken',
    headerName: 'Project',
    width: 120,
  },
  {
    field: 'formToken',
    headerName: 'Form',
    width: 120,
  },
  {
    field: 'accountToken',
    headerName: 'Account',
    width: 120,
  },
  {
    field: 'fileSize',
    headerName: 'Size (bytes)',
    width: 130,
  },
  {
    field: 'key',
    headerName: 'Key',
    width: 220,
  },
  {
    field: 's3Key',
    headerName: 'S3 Key',
    width: 320,
  },
  {
    field: 'version',
    headerName: 'Version',
    width: 90,
  },
  {
    field: 'uploadedAt',
    headerName: 'Uploaded At',
    width: 170,
    valueGetter: (params) =>
      params.row.uploadedAt ? new Date(params.row.uploadedAt).toLocaleString() : '',
  },
  {
    field: 'uploadedBy',
    headerName: 'Uploaded By',
    width: 120,
  },
  {
    field: 'userToken',
    headerName: 'User Token',
    width: 140,
  },
];
